<script setup lang="ts">
/**
 * Final Dividends — Directors' Resolutions In Writing (EGM 소집 + 배당 권고).
 *   원본: Directors_ Resolution for Final Dividends (Multiple / Sole Corporate / Sole Individual).
 *   member(s) 문구만 시나리오로 갈리고 본문은 동일 → 한 컴포넌트로 통합.
 *   서명 = 이사 전원([[Signers]]) → dr_Signers.
 */
import { inject, ref } from 'vue';
import CddVarField from '../cdd/CddVarField.vue';
import AgmSigners from '../cdd/AgmSigners.vue';
import { DIV_SCENARIO, type DivScenario } from './scenario';
import './agmDoc.css';

const scenario = inject(DIV_SCENARIO, ref<DivScenario>('multiple'));
const isMulti = () => scenario.value === 'multiple';
</script>

<template>
  <div class="agm-doc">
    <div class="doc-head">
      <div><b><CddVarField field-key="company_name" label="Company Name" /></b></div>
      <div>Company Registration No. <CddVarField field-key="company_registration_no" label="Reg No" /></div>
      <div>(Incorporated in the Republic of Singapore)</div>
      <div>(the &ldquo;Company&rdquo;)</div>
    </div>

    <div class="doc-title">DIRECTORS&rsquo; RESOLUTIONS IN WRITING</div>
    <div class="doc-sub">PURSUANT TO THE COMPANY'S CONSTITUTION</div>

    <div class="sec-title">EXTRAORDINARY GENERAL MEETING</div>
    <p class="doc-p">
      RESOLVED that an Extraordinary General Meeting of the Company be convened for the purpose of considering and,
      if thought fit, passing the following resolutions as ordinary resolutions: -
    </p>

    <div class="sec-title" style="text-align:center">FINAL DIVIDEND</div>
    <p class="doc-p">
      NOTED THAT the Company has sufficient profits for the declaration of a final dividend of
      <CddVarField field-key="dividend_amount" label="Dividend Amount" /> to its {{ isMulti() ? 'members' : 'member' }}.
    </p>
    <p class="doc-p">
      RESOLVED THAT a final one-tier tax exempt dividend of <CddVarField field-key="dividend_amount" label="Dividend Amount" />
      in respect of the financial year ended <CddVarField field-key="financial_year_end" label="Financial Year End" />
      be recommended for payment out of the profits of the Company to the {{ isMulti() ? 'members' : 'member' }}
      whose names appear on the Register of Members.
    </p>
    <p class="doc-p">
      RESOLVED THAT subject to the approval of the {{ isMulti() ? 'members' : 'member' }} being had and obtained as aforesaid,
      any Director be and is hereby authorized to execute the dividend vouchers to be issued to the
      {{ isMulti() ? 'members' : 'member' }} of the Company.
    </p>

    <p class="doc-p">Dated: <CddVarField field-key="resolution_date" label="Resolution Date" /></p>

    <div class="sign-block">
      <AgmSigners var-key="dr_Signers" board-label="Director" />
    </div>
  </div>
</template>
